
import { Component, Vue } from 'vue-property-decorator'
import { GET_CONFIG } from '~/graphql/gql/config'
import { GQLConfig } from '~/graphql/__generated__/interfaces'
import {
  YOTTLY_TRACKING_EVENT_NAME,
  YottlyEvent,
} from '~/utils/tracking/yottly'

interface YottyConfig {
  id: string
  domain?: string
  enabled: boolean
}

@Component({
  apollo: {
    getConfig: {
      fetchPolicy: 'cache-only',
      query: GET_CONFIG,
    },
  },
})
export default class TheTrackingYottly extends Vue {
  getConfig: GQLConfig
  eventListener?: Function

  get config(): YottyConfig {
    const { yottly: id = '0', yottlyDomain: domain } = this.getConfig.shopConfig

    return {
      domain,
      enabled: id !== '0',
      id,
    }
  }

  created() {
    const { id, domain, enabled } = this.config

    if (enabled) {
      this.eventListener = (evt: YottlyEvent) => {
        if (!window.diffAnalytics) {
          return
        }

        const { onOrderPage = false, articles = [] } = evt.detail.data
        window.diffAnalytics.cartInteraction({
          content: articles.map(({ count, articleId }) => ({
            amount: count,
            productId: articleId,
          })),
          onOrderPage,
        })
      }
      window.addEventListener(
        YOTTLY_TRACKING_EVENT_NAME,
        this.eventListener as EventListener
      )

      const script = document.createElement('script')
      script.setAttribute('src', `${domain}/script.js?tp=${id}`)
      script.setAttribute('async', 'async')
      document.head.appendChild(script)
    }
  }

  beforeDestroy() {
    if (this.eventListener) {
      window.removeEventListener(
        YOTTLY_TRACKING_EVENT_NAME,
        this.eventListener as EventListener
      )
    }
  }

  render() {
    return null
  }
}
